'use client';

import { useRef, useState } from 'react';
import { Button } from '@/shared/ui/core';
import { useClickOutside } from '@/shared/lib/hooks/use-click-outside';
import { NotificationsMenu } from '@/shared/ui/kit/notifications-menu';
import { BellSimpleRingingIcon } from '@phosphor-icons/react/ssr';
import { useNotificationsStore, selectUnreadCount, selectPulse } from '@/shared/lib/notifications/store';
import { useNotificationsMenuTrigger } from '../lib/use-notifications-menu-trigger';
import styles from './notifications-menu-trigger.module.scss';


export function NotificationsMenuTrigger () {
    const { isOpen, toggleOpen } = useNotificationsMenuTrigger();
    const unreadCount            = useNotificationsStore(selectUnreadCount);
    const pulse                  = useNotificationsStore(selectPulse);
    const buttonRef              = useRef<HTMLButtonElement>(null);
    const menuRef                = useClickOutside<HTMLDivElement>(toggleOpen, [ buttonRef ]);
    const [ baseline ]           = useState(pulse);
    const shouldShake            = pulse > baseline;

    return (
        <div className={ styles.wrapper }>
            <Button
                variant="naked"
                className={ styles.root }
                onClick={ toggleOpen }
                ref={ buttonRef }
            >
                <span
                    key={ pulse }
                    className={ styles.icon_wrap }
                    data-pulse={ shouldShake ? 'on' : undefined }
                >
                    <BellSimpleRingingIcon
                        size={ 32 }
                        weight="fill"
                        className={ styles.icon }
                    />
                </span>

                {
                    unreadCount > 0 &&
                    <span className={ styles.badge }>
                        { unreadCount > 9 ? '9+' : unreadCount }
                    </span>
                }
            </Button>

            {
                isOpen &&
                <NotificationsMenu
                    toggleOpen={ toggleOpen }
                    ref={ menuRef }
                />
            }
        </div>
    );
};
